import { Autocomplete, Box, Button, Checkbox, Chip, FormControl, FormControlLabel, IconButton, InputAdornment, InputBase, OutlinedInput, Paper, Radio, RadioGroup, TextField, Typography, MenuItem, Select, Stack } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect, useRef, useState } from "react";
import people from "../../../../assets/svg/ellipse.svg";
import { useFormik } from "formik";
import dayjs from "dayjs";
import { addCampaign, checkPromoCodeAvailability, generatePromoCode, getCampaigns, notifyCustomersMessage, notifyCustomersOffer, sendInAppMessage, sendReceiveMessageNotification } from "../../../../helper/campaign";
import { useDispatch, useSelector } from "react-redux";
import { getAllCouriersFromEasyShip, getAllUsers, getBrands, getCustomersByRoutePartnerId } from "../../../../helper/functions";
import { toast } from "react-toastify";
import { setCampaigns } from "../../../../store/campaign";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import countries from "../../../../Contries.json";

const initalValues = {
    header: "",
    forAllUsers: false,
    forAllCustomers: false,
    emails: [],
    message: "",
    mobileMessage: "",
    appMessage: "",
    notificationMessage: "",
    countries: [],
    messageType: "General",
    deliveryRoute: "email_notification"
}

const SendMessage = ({ setAddFundDrawer }) => {
    const dispatch = useDispatch();
    const [customerMails, setCustomerMails] = useState([]);
    const [filterCustomerMails, setFilterCustomerMails] = useState([]);
    const [brands, setBrands] = useState([]);
    const [couriers, setCouriers] = useState([]);
    const user = useSelector((state) => state.auth.value);
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const quillRef = useRef(null);
    console.log(user, "userdfsdf");
    useEffect(() => {
        const getCustomers = async () => {
            const customers = await getCustomersByRoutePartnerId(user?.routePartnerId);
            setCustomerMails(customers)
            setFilterCustomerMails(customers)
            console.log(customers, "customers1111")
        }
        const getUsers = async () => {
            const users = await getAllUsers();
            console.log(users, "usersacds")
            setCustomerMails(users)
            setFilterCustomerMails(users)
        }
        if (user) {
            if (user?.role === "Route Partner Admin") {
                getCustomers()
            }
            else {
                getUsers()
            }
        }
    }, [user])
    const countryChangeHandler = (event, newValue) => {
        formik.setFieldValue("countries", newValue);
        const countries = newValue.map(country => country.name);
        console.log(countries, "countries");
        setFilterCustomerMails(customerMails?.filter(customer => countries.includes(customer.country)));
    }
    const formik = useFormik({
        initialValues: initalValues,
        onSubmit: async (values) => {
            console.log(values, "values");
            // addCampaign({ campaignType: "send_message", addedBy: user?.id, ...values }).then(async (res) => {
            //     const response = await getCampaigns();
            //     dispatch(setCampaigns(response))
            //     setAddFundDrawer(false);
            //     // toast.success("Send");
            // });
            if(values.deliveryRoute == "email_notification"){
                notifyCustomersMessage(values.forAllCustomers || values.forAllUsers, filterCustomerMails, values.emails, values, user).then((res) => {
                    toast.success("Message Sent Successfully");
                });
            }
            else if(values.deliveryRoute == "push_notification"){
                sendReceiveMessageNotification(values.header, values.forAllCustomers || values.forAllUsers, filterCustomerMails, values.emails, values, user).then((res)=>{
                    toast.success("Notification Sent Successfully");
                });
            }
            else if(values.deliveryRoute == "in_app_message"){
                sendInAppMessage(values.forAllCustomers || values.forAllUsers, filterCustomerMails, values.emails, values, user).then((res)=>{
                    toast.success("In App Message Sent Successfully");
                });
            }
            else if(values.deliveryRoute == "all"){
                notifyCustomersMessage(values.forAllCustomers || values.forAllUsers, filterCustomerMails, values.emails, values, user).then((res) => {
                    toast.success("Message Sent Successfully");
                });
                sendReceiveMessageNotification(values.notificationMessage, values.forAllCustomers || values.forAllUsers, filterCustomerMails, values.emails, values, user).then((res)=>{
                    toast.success("Notification Sent Successfully");
                });
                sendInAppMessage(values.forAllCustomers || values.forAllUsers, filterCustomerMails, values.emails, values, user).then((res)=>{
                    toast.success("In App Message Sent Successfully");
                });
            }
        }
    })
    const addEmoji = (emoji) => {
        const editor = quillRef.current.getEditor();
        const range = editor.getSelection(true);
        editor.insertText(range.index, emoji.native);
        editor.setSelection(range.index + emoji.native.length);
        setShowEmojiPicker(false);
    };
    return (
        <Box>
            <Box
                style={{
                    minHeight: "83vh",
                }}
            >
                <Box sx={{ marginX: "20px", paddingTop: "10px" }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                        Header (max 8 words)
                    </Typography>
                    <TextField variant="outlined" size="small" fullWidth sx={{ marginTop: "8px" }} value={formik.values.header} onChange={(e) => formik.setFieldValue("header", e.target.value)} />
                </Box>

                {/* Message Type Selection */}
                <Box sx={{ paddingX: "20px", paddingTop: "10px" }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                        Message Type
                    </Typography>
                    <FormControl fullWidth>
                        <Select
                            size="small"
                            value={formik.values.messageType}
                            onChange={e => {
                                formik.setFieldValue("messageType", e.target.value);
                                formik.setFieldValue("message", "");
                                formik.setFieldValue("mobileMessage", "");
                                formik.setFieldValue("appMessage", "");
                                formik.setFieldValue("notificationMessage", "");
                            }}
                            sx={{ marginTop: "8px" }}
                        >
                            <MenuItem value="General">General</MenuItem>
                            <MenuItem value="Urgent Alert">Urgent Alert</MenuItem>
                            <MenuItem value="Promotion">Promotion</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                {/* Delivery Route Selection */}
                <Box sx={{ paddingX: "20px", paddingTop: "10px" }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                        Delivery Route
                    </Typography>
                    <FormControl fullWidth>
                        <Select
                            size="small"
                            value={formik.values.deliveryRoute}
                            onChange={e => {
                                formik.setFieldValue("deliveryRoute", e.target.value);
                                formik.setFieldValue("message", "");
                                formik.setFieldValue("mobileMessage", "");
                                formik.setFieldValue("appMessage", "");
                                formik.setFieldValue("notificationMessage", "");
                            }}
                            sx={{ marginTop: "8px" }}
                        >
                            {/* <MenuItem value="push_notification">Push Notification</MenuItem> */}
                            <MenuItem value="email_notification">Email notification</MenuItem>
                            <MenuItem value="in_app_message">In App message</MenuItem>
                            <MenuItem value="all">All</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                {/* Country Multiple Autocomplete */}
                <Box sx={{ paddingX: "20px", paddingTop: "10px" }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                        Country
                    </Typography>
                    <FormControl fullWidth>
                        <Autocomplete
                            multiple
                            size="small"
                            options={countries}
                            getOptionLabel={option => option.flag + ' ' + option.name}
                            value={formik.values.countries}
                            onChange={countryChangeHandler}
                            sx={{ marginTop: "8px" }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select countries"
                                />
                            )}
                            renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                    <Chip
                                        variant="outlined"
                                        label={option.flag + ' ' + option.name}
                                        {...getTagProps({ index })}
                                    />
                                ))
                            }
                        />
                    </FormControl>
                </Box>

                {user?.role === "Route Partner Admin" && <Box
                    sx={{
                        paddingX: "20px",
                    }}
                >
                    <FormControlLabel
                        label="For all customers"
                        control={
                            <Checkbox
                                size="small"
                                onChange={(event) => {
                                    if (event.target.checked) {
                                        formik.setFieldValue("emails", [])
                                    }
                                    formik.setFieldValue("forAllCustomers", event.target.checked)
                                }}
                            />
                        }
                    />
                </Box>}
                {user?.role != "Route Partner Admin" && <Box
                    sx={{
                        paddingX: "20px",
                    }}
                >
                    <FormControlLabel
                        label="For all users"
                        control={
                            <Checkbox
                                size="small"
                                onChange={(event) => {
                                    if (event.target.checked) {
                                        formik.setFieldValue("emails", [])
                                    }
                                    formik.setFieldValue("forAllUsers", event.target.checked)
                                }}
                            />
                        }
                    />
                </Box>}
                <Box sx={{ paddingX: "20px", paddingTop: "10px" }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                        Email
                    </Typography>
                    <FormControl fullWidth>
                        <Autocomplete
                            multiple
                            size="small"
                            options={filterCustomerMails?.map((option) => option.email)}
                            disabled={formik?.values?.forAllCustomers || formik?.values?.forAllUsers}
                            value={formik?.values?.emails || []}
                            onChange={(event, newValue) => {
                                formik.setFieldValue("emails", newValue);
                            }}
                            sx={{ marginTop: "8px" }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select emails"
                                />
                            )}
                            renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                    <Chip
                                        variant="outlined"
                                        label={option}
                                        {...getTagProps({ index })}
                                    />
                                ))
                            }
                        />
                    </FormControl>
                </Box>
                <Box sx={{ paddingX: "20px", paddingTop: "15px" }}>
                    <Stack spacing={2}>
                        {/* Mobile Message */}
                        {/* {(formik.values.deliveryRoute === "push_notification" || formik.values.deliveryRoute === "all") && (
                            <Box style={{ position: "relative" }}>
                                <Typography sx={{ fontSize: "13px", fontWeight: 500, marginBottom: '4px' }}>Mobile Message</Typography>
                                <TextField
                                    value={formik?.values?.mobileMessage}
                                    onChange={e => formik.setFieldValue("mobileMessage", e.target.value)}
                                    multiline
                                    minRows={3}
                                    maxRows={6}
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Enter mobile message"
                                    sx={{ marginTop: "8px" }}
                                />
                            </Box>
                        )} */}
                        {/* Notification Message */}
                        {(formik.values.deliveryRoute === "in_app_message" || formik.values.deliveryRoute === "all") && (
                            <Box style={{ position: "relative" }}>
                                <Typography sx={{ fontSize: "13px", fontWeight: 500, marginBottom: '4px' }}>Notification Message</Typography>
                                <TextField variant="outlined" size="small" fullWidth sx={{ marginTop: "8px" }} value={formik.values.header} onChange={(e) => formik.setFieldValue("header", e.target.value)} />
                            </Box>
                        )}
                        {/* App Message */}
                        {(formik.values.deliveryRoute === "in_app_message" || formik.values.deliveryRoute === "all") && (
                            <Box style={{ position: "relative" }}>
                                <Typography sx={{ fontSize: "13px", fontWeight: 500, marginBottom: '4px' }}>App Message</Typography>
                                <TextField
                                    value={formik?.values?.appMessage}
                                    onChange={e => formik.setFieldValue("appMessage", e.target.value)}
                                    multiline
                                    minRows={3}
                                    maxRows={6}
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Enter app message"
                                    sx={{ marginTop: "8px" }}
                                />
                            </Box>
                        )}
                        {/* Email Message */}
                        {(formik.values.deliveryRoute === "email_notification" || formik.values.deliveryRoute === "all") && (
                            <Box style={{ position: "relative" }}>
                                <Typography sx={{ fontSize: "13px", fontWeight: 500, marginBottom: '4px' }}>Email Message</Typography>
                                <ReactQuill
                                    value={formik?.values?.message}
                                    sx={{ position: 'relative', mb: 5 }}
                                    ref={formik.values.deliveryRoute === "email_notification" || formik.values.deliveryRoute === "all" ? quillRef : undefined}
                                    onChange={(value) => formik.setFieldValue("message", value)}
                                    style={{
                                        width: "100%",
                                        height: "100px",
                                        marginTop: "8px",
                                    }}
                                    theme="snow"
                                />
                            </Box>
                        )}
                    </Stack>
                </Box>
            </Box>
            {/* Button at the very bottom of the modal content */}
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 6,
                    paddingBottom: 3,
                    position: "relative",
                    bottom: 0,
                }}
            >
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: "#481AA3",
                        color: "#fff",
                        border: "none",
                        boxShadow: "0px 4px 12px rgba(72, 26, 163, 0.3)",
                        padding: "12px 24px",
                        borderRadius: "8px",
                        fontSize: "14px",
                        fontWeight: 600,
                        textTransform: "none",
                        minWidth: "180px",
                        height: "48px",
                        transition: "all 0.3s ease",
                        "&:hover": {
                            backgroundColor: "#5E17EB",
                            boxShadow: "0px 6px 16px rgba(72, 26, 163, 0.4)",
                            transform: "translateY(-2px)",
                        },
                        "&:active": {
                            transform: "translateY(0px)",
                        },
                    }}
                    onClick={formik.handleSubmit}
                >
                    Send Messaging
                </Button>
            </Box>
        </Box>
    )
}

export default SendMessage;